module.exports = __webpack_public_path__ + "static/vregattaHome_3-f17fd341e456676186aba22d170a7ee1.png";